import { cn } from "@onclicks/sharedcomponents/ui";
import type { AnchorDoc } from "../../types/payload";
import { CMSLinkType } from "../../types/CMSLink";
import Link from "next/link";
import React from "react";
import { Button, type ButtonProps } from "./ui/Button";

export const CMSLink: React.FC<
  CMSLinkType<ButtonProps["variant"], ButtonProps["size"]>
> = (props) => {
  const {
    type,
    appearance = "inline",
    children,
    className,
    label,
    newTab,
    reference,
    size: sizeFromProps,
    url,
  } = props;

  let href: string | undefined | null = url;

  href = getHref();

  if (!href) return null;

  const isAnchor = href.startsWith("#") || href.startsWith("/#");
  const size = appearance === "link" ? "clear" : sizeFromProps;
  const newTabProps = newTab
    ? { rel: "noopener noreferrer", target: "_blank" }
    : {};

  // Button autour de a et Link = lien ressemble à un bouton graphique, propriété asChild transmet toutes ses propriétés CSS à ses enfants
  // apparence inline = apparence simple, texte standard
  if (isAnchor) {
    if (appearance === "inline") {
      return (
        <a href={href} className={cn(className)}>
          {label}
          {children}
        </a>
      );
    } else {
      return (
        <Button asChild className={className} size={size} variant={appearance}>
          <a href={href} className={cn(className)}>
            {label}
            {children}
          </a>
        </Button>
      );
    }
  } else {
    if (appearance === "inline") {
      return (
        <Link className={cn(className)} href={href} {...newTabProps}>
          {label && label}
          {children && children}
        </Link>
      );
    } else {
      return (
        <Button asChild className={className} size={size} variant={appearance}>
          <Link className={cn(className)} href={href} {...newTabProps}>
            {label && label}
            {children && children}
          </Link>
        </Button>
      );
    }
  }

  function getHref() {
    if (
      type === "reference" &&
      reference?.value &&
      typeof reference.value === "object"
    ) {
      if (reference.relationTo === "anchors") {
        // Pour Anchors
        const anchorVal = (reference.value as AnchorDoc).anchor;
        return `/#${anchorVal.replace(/^#/, "")}`;
      } else if ("slug" in reference.value && reference.value.slug) {
        // Pour Pages / Posts
        return `${reference.relationTo !== "pages" ? `/${reference.relationTo}` : ""}/${reference.value.slug}`;
      }
    }

    if (type === "custom" && url) {
      return url;
    }
    return null;
  }
};
